import { render, staticRenderFns } from "./NotFound404Page.vue?vue&type=template&id=690890f3&"
import script from "./NotFound404Page.vue?vue&type=script&lang=js&"
export * from "./NotFound404Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports